import React from "react";
import Dropzone from "react-dropzone";
import attach from "./../../assets/images/attach.svg";

// for pdf files
class FileUpload extends React.Component {
  state = { warningMsg: "" };

  onDrop = (accepted, rejected) => {
    if (Object.keys(rejected).length !== 0) {
      const message = "Please submit a valid .pdf file(max size: 5MB)";  
      this.props.hasFileError(true); 
      this.setState({ warningMsg: message });
    } else {
      this.props.addFile(accepted);     
      this.setState({ warningMsg: "" });
      var blobPromise = new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(accepted[0]);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        };
      });
      blobPromise.then(value => {
        this.props.fileBaseValue(value,accepted[0]);
      });
    }
  };

  render() {
    const { files } = this.props;
    const render =
      Object.keys(files).length !== 0 ? ( 
        files.map(file => <p  className="hello" key={file.name} style={{textAlign: 'left',height: '20px', marginTop: '1%'}}>
         <i class="fas fa-paperclip " aria-hidden="true"></i> 
        </p>)        
      ) : (
        <p className="hello" style={{ textAlign: 'left',height: '20px', marginTop: '1%'}}>     
        <img src={attach} style={{height: '15px', width: '15px'}}/>
        </p>
      );
    return (
      <div style={{width: '100%'}}>         
        <Dropzone
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // height: "50vh",
            // border: " 2px dashed"
          }}
          multiple={false}
          maxSize={5242880}       
          accept="application/pdf,"
          onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
        >
          {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
            // if (isDragReject) return "Please submit a valid .pdf file(max size: 5MB)";
            if (isDragReject) return  <img src={attach} style={{height: '15px', width: '15px'}}/>;
            return render;
          }}
        </Dropzone>
      </div>
    );
  }
}

export default FileUpload;
